document.querySelectorAll('.product__media-invert-toggle').forEach((button) => {
  const gallery = button.closest('media-gallery');
  if (!gallery) return;

  button.addEventListener('click', () => {
    const inverted = gallery.classList.toggle('media-gallery--inverted');
    button.setAttribute('aria-pressed', inverted);
    button.setAttribute(
      'aria-label',
      inverted ? button.dataset.labelOff : button.dataset.labelOn
    );
  });
});
